


class TaskListener {
    private taskList: any[] = [];

     isTasking: boolean = false;
     isTimer: any = null;
    addTask(task: any) {
        this.taskList.push(task);
    }

    clearTask() {
        this.taskList = [];
        this.isTasking=false;
    }

    changeIsTasking(value: boolean) {
        this.isTasking = value;
    }

    clearTimer() {
        if (this.isTimer) {
            clearTimeout(this.isTimer);
            this.isTimer = null;
        }
    }

    startTask(IntervalDurationMs: number = 64) {

      this.isTimer = setTimeout(() => {
        const task=this.taskList.shift();
        task && task();
        if(this.isTasking){
          this.startTask();
        }
        // 任务状态 false  存在未完成任务
        if(!this.isTasking && this.taskList.length >0){
          this.startTask(IntervalDurationMs);
        }
        console.log('task handle');
      }, IntervalDurationMs);
    }


}

export default new TaskListener();